import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { DatePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom
} from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';

import { routes } from './app.routes';
import { ErrorInterceptor, DEFAULT_TIMEOUT } from './interceptor/error-interceptor.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
  
    importProvidersFrom(
      ToastrModule.forRoot(),
      MatDialogModule
    ),

    provideHttpClient(withInterceptorsFromDi()),

    {
      provide: DEFAULT_TIMEOUT,
      useValue: 900000 // 15 minutes – long-running grocery API
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },

    DatePipe,

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: false }
    },

    provideRouter(routes),
    provideAnimationsAsync(),


    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '693033811375-rrbm6pabsb6afae5iq72hqvjunlnka76.apps.googleusercontent.com'
            )
          }
        ],
        onError: (err) => console.error(err)
      } as SocialAuthServiceConfig
    }
  ]
};
